import { InteractionModel } from '@/app/shared/models/customer/interaction.model';
import { TicketModel } from '@/app/shared/models/customer/ticket.model';
import { HttpService } from '@/app/shared/services/http.service';
import { env } from '@/environments';
import { refsService } from '../../refs.service';

export class TicketService extends HttpService {
  public async getTicketList(
    filter?: string,
    limit = 999
  ): Promise<TicketModel[]> {
    return await this.get<TicketModel[]>(`${env.customerUri}/Tickets`, {
      params: { filter, limit },
      headers: { tenantId: refsService.modules.company.account.Id },
    }).then(({ data }) => data);
  }
  public async getTicketById(ticketId: string): Promise<TicketModel> {
    return await this.get<TicketModel>(
      `${env.customerUri}/Tickets/${ticketId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async createTicket(ticket: TicketModel): Promise<{ Id: string }> {
    return await this.post<{ Id: string }, TicketModel>(
      `${env.customerUri}/Tickets`,
      ticket,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async completeTicket(ticketId: string): Promise<void> {
    await this.post(
      `${env.customerUri}/Tickets/${ticketId}/Completed`,
      {},
      {
        headers: { tenantId: refsService.modules.company.account.Id },
      }
    );
  }

  public async closeTicket(ticketId: string): Promise<void> {
    await this.post(
      `${env.customerUri}/Tickets/${ticketId}/Close`,
      {},
      {
        headers: { tenantId: refsService.modules.company.account.Id },
      }
    );
  }
  public async getInteractionsList(
    ticketId: string,
    filter?: string,
    limit = 999
  ): Promise<InteractionModel> {
    return await this.get<InteractionModel>(
      `${env.customerUri}/Tickets/${ticketId}/interactions`,
      {
        params: { filter, limit },
        headers: { tenantId: refsService.modules.company.account.Id },
      }
    ).then(({ data }) => data);
  }
  public async getTicketInteractionById(
    ticketId: string,
    interactionsId: string
  ): Promise<InteractionModel[]> {
    return await this.get<InteractionModel[]>(
      `${env.customerUri}/Tickets/${ticketId}/interactions/${interactionsId}`,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
  public async createInteraction(
    interaction: InteractionModel
  ): Promise<{ Id: string }> {
    return await this.post<{ Id: string }, InteractionModel>(
      `${env.customerUri}/Tickets/${refsService.modules.ticket.ticket.Id}/interactions`,
      interaction,
      { headers: { tenantId: refsService.modules.company.account.Id } }
    ).then(({ data }) => data);
  }
}
